import React from 'react';
import { FeedbackIconProps } from './FeedbackIcon';

const FeedbackThumbsUpDownIcon = ({ size, style }: FeedbackIconProps) => (
  <svg
    width={size}
    height={size}
    style={style}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3197_17802)'>
      <path
        d='M7 3.5C7 3.17917 6.7375 2.91667 6.41667 2.91667H3.395L3.78 1.06167L3.79167 0.9275C3.79167 0.746667 3.71583 0.583333 3.59917 0.460833L3.13833 0L0.256667 2.88167C0.0991667 3.03917 0 3.26083 0 3.5V7.29167C0 7.77583 0.390833 8.16667 0.875 8.16667H4.8125C5.17417 8.16667 5.48333 7.945 5.6175 7.63583L6.93583 4.55C6.97667 4.45083 7 4.34 7 4.22917V3.5ZM5.83333 4.15917L4.62 7H1.16667V3.6225L2.2925 2.49667L1.96 4.08333H5.83333V4.15917ZM13.125 5.83333H9.1875C8.82583 5.83333 8.51667 6.055 8.3825 6.36417L7.06417 9.45C7.02333 9.54917 7 9.66 7 9.77083V10.5C7 10.8208 7.2625 11.0833 7.58333 11.0833H10.605L10.22 12.9383L10.2083 13.0783C10.2083 13.2592 10.2842 13.4225 10.4008 13.545L10.8617 14L13.7433 11.1183C13.9008 10.9608 14 10.7392 14 10.5V6.70833C14 6.22417 13.6092 5.83333 13.125 5.83333ZM12.8333 10.3775L11.7075 11.5033L12.04 9.91667H8.16667V9.84083L9.38 7H12.8333V10.3775Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_3197_17802'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default FeedbackThumbsUpDownIcon;
